import { createSlice } from "@reduxjs/toolkit";
import { number_format } from "../utils/utils";
import moment from "moment";
import "moment/locale/es";

moment.locale("mx");

const reminder = moment().add(2, 'days').format('DD/MM/YYYY') + ' 1:00 PM'
const created_at = moment().format('DD/MM/YYYY') + ' 9:32 AM'

export const agentsSlice = createSlice({
  name : 'agents',
  initialState: {
  arrNuevoCliente: {
    tipo_persona: 'fisica',
    razon_social: '',
    comision: '',
    genero: '',
    titulo: '',
    paterno: '',
    materno: '',
    nombre: '',
    nombre_completo: '',
    value: '',
    label: '',
    rfc: '',
    birthday: '',
    nacionalidad: 'MEXICANO',
    categoria: '',
    curp: '',
    registro: '',
    ejecutivo: '',
    expediente: '',
    fecha_registro: moment().format('YYYY-MM-DD'),
    vendedor: '',
    empresa: '',
    grupo: '',
    giro: '',
    puesto: '',
    contacto_de: '',
    notas: '',
    newAcceso: false,
    arrAccesos: [],
    newDireccion: false,
    arrDirecciones: [],
    newCorreo: false,
    arrCorreos: [],
    isContratante: true,
    isCompania: false,
    isAgente: false,
    isVendedor: false,
    isEjecutivo: false,
    isProspecto: false,
  },


    showModalNuevaCotizacion: false,
    newCotizacion: {
      // Aquí va todo lo necesario para la nueva cotización
      id_cotizacion: '',
    },
    dataTramite: {},
    showSidebarNuevaCotizacion: false,
    showUrgentes: false,
    dataArray: [],

    logged: false,
    array_usuarios: [
      { nombre: 'Usuario 1', correo: 'usuario1@wsoft.com.mx' , password: '123', tipo_usuario: '1' },//home
      { nombre: 'Usuario 2', correo: 'usuario2@wsoft.com.mx' , password: '123', tipo_usuario: '2' },//home caja
      { nombre: 'Usuario 3', correo: 'usuario3@wsoft.com.mx' , password: '123', tipo_usuario: '3' },//home finanzas
      { nombre: 'Usuario 4', correo: 'usuario4@wsoft.com.mx' , password: '123', tipo_usuario: '4' },//home pocesos

      {
        "type": "General",
        "tipo_usuario": "5",
        "nombre": "Alba Legaspi", // name
        "password": "123456",
        "correo": "alba.legaspi@ib-ins.com", // email
        "phone": "6642325808",
      }, {
        "type": "Customer Service",
        "tipo_usuario": "1",
        "nombre": "Chantal Leyva", // name
        "password": "123456",
        "correo": "chantal.leyva@ib-ins.com", // email
        "phone": "6644136546"
      }, {
        "type": "Customer Service",
        "tipo_usuario": "1",
        "nombre": "David Armando", // name
        "password": "123456",
        "correo": "david.ledesma@ib-reg.com", // email
        "phone": "6644092997"
      }, {
        "type": "Customer Service",
        "tipo_usuario": "1",
        "nombre": "Diana Valenzuela", // name
        "password": "123456",
        "correo": "plates@ib-reg.com", // email
        "phone": "6196169717"
      }, {
        "type": "Customer Service",
        "tipo_usuario": "1",
        "nombre": "Francela Castro", // name
        "password": "123456",
        "correo": "f.castro@ib-ins.com", // email
        "phone": "6644094853"
      }, {
        "type": "Costumer Service",
        "tipo_usuario": "1",
        "nombre": "Oneida Martinez", // name
        "password": "123456",
        "correo": "oneida.martinez@ib-ins.com", // email
        "phone": "6631053025"
      }, {
        "type": "Customer Service",
        "tipo_usuario": "1",
        "nombre": "Omar Romero", // name
        "password": "123456",
        "correo": "auxplacas@interbrokers.mx", // email
        "phone": ""
      }, {
        "type": "Cobranza",
        "tipo_usuario": "2",
        "nombre": "Maribel Bonilla", // name
        "password": "123456",
        "correo": "cobranza3@interbrokers.mx", // email
        "phone": "6644094852"
      }, {
        "type": "Cobranza",
        "tipo_usuario": "2",
        "nombre": "Rosy Garcia", // name
        "password": "123456",
        "correo": "cobranza2@interbrokers.mx", // email
        "phone": ""
      }, {
        "type": "Finanzas",
        "tipo_usuario": "3",
        "nombre": "Violeta Torres", // name
        "password": "123456",
        "correo": "cobranza@interbrokers.mx", // email
        "phone": "6196093597"
      }, {
        "type": "Procesos",
        "tipo_usuario": "4",
        "nombre": "Iris Orozco", // name
        "password": "123456",
        "correo": "registration@ib-reg.com", // email
        "phone": ""
      }, {
        "type": "Procesos",
        "tipo_usuario": "4",
        "nombre": "Samuel Cruz", // name
        "password": "123456",
        "correo": "procesos@ib-reg.com", // email
        "phone": ""
      },




    ],
    tipo_usuario: '',
    
    nombre: '',
    initData : [],
    toastAlert: {
      show : false,
      message : '',
      type: '',
    },
    home: {
      section : 1,
      arrClientes: [],  
      arrSelectClientes: [],
      arrSections: {
        cotizaciones: false,
        orden_trabajo: false,
        caja: false,
        creditos: false,
        finanzas: false,
        procesos: false,
      },
      arrPorPagar: [],
      arrPagados: [],
      arrVencidos: [],
      arrRenovaciones: [],
      arrContrato: [],
      dataRecibo: [],
      showModalRecibos: false,
      showModalFiltros: false,
      
      showModalRealizarCobro: false,
      showSidebarModificarOT: false,
      showModalVisualizarOT: false,
      isLoadingViewContrato : false,
      isLoadPanel: false,
      recibosSearch: '',
      customDate: false,
      fechaInicio: '',
      fechaFin: '',
      modalRecibo:{
        sectionRecibo: 2,
        modalEditarPrimas: false,
        modalEndoso: false,
        modalObservacion: false,
        modalModificarRecibo: false,
        modalFechaPago: false,
        modalVerEndoso: false,
        modalMarcarPago: false,
        isLoadingVerEndoso: false,
        dataPanel: [],
        isLoadPanel: false,
        numero_endoso: '',
        id_endoso: '',
        isLoadingConfirmacion: false,
        dataEndoso: [],
      }
    },
    directorio:{},
    nube: {},
    productividad: {},
    actividad: {},
    configuracion: {},

    arrTramites: []

  },
  reducers: {
    updateModalNuevaCotizacionStatus: (state, data) => {
      state.showModalNuevaCotizacion = data.payload
    },
    loginSuccess: (state) => {
      state.logged = false
    },
    changeName: (state,data) => {
      state.nombre = data.payload
    },
    setInitData: (state,data) => {
      state.initData = data.payload
    },
    setStateGlobal: (state, action) => {
      const newData = action.payload;
      return {
        ...state,
        ...newData
      }
    },
    setStateHome: (state, action) => {
      const newData = action.payload;
      return {
        ...state,
        home: {...state.home, ...newData}
      }
    },
    setStateHomeRecibo: (state, action) => {
      const newData = action.payload;
      return {
        ...state,
        home: {
          ...state.home,
          modalRecibo: {
            ...state.home.modalRecibo,
            ...newData
          }
        }
      }
    },
    updatePrimaNetaRecibo: (state,action) => {
      let { payload } = action;
      let { section, poliza, primaNeta } = payload;
      const newArray = state.home[section].map( element => {
        if(element.numero_poliza===poliza){
          element.prima_neta = primaNeta;
        }
        return element;
      })
      state.home[section] = newArray;
      state.home.arrContrato.configuracion.prima_neta = number_format(primaNeta);
    },
    updateStatusRecibo: (state,action) => {
      const { payload } = action;
      const { id_historial,status } = payload;
      const newArray = state.home.arrContrato.contratos.map( element => {
        if(element.id_historial==id_historial){
          element.estado  = status;
        }
        return element;
      });
      state.home.arrContrato.contratos = newArray;
    },
    updateStatusEndoso: (state,action) => {
      let { payload } = action;
      let { id_historial,status,id_cobro } = payload;
      const newArray = state.home.arrContrato.contratos.map( element => {
        if(element.id_historial==id_historial){
          element.endosos.map( endoso => {
            if(endoso.id_cobro==id_cobro){
              endoso.status = status;
            }
            return endoso;
          })
        }
        return element;
      });
      state.home.arrContrato.contratos = newArray;
    },
    marcarPagoRecibo: (state,action) => {
      const { payload } = action;
      const { section, poliza } = payload;
      return {
        ...state,
        home: {
          ...state.home,
          [section]: [...state.home[section].filter( element => {
            if(element.numero_poliza!==poliza){
              return element
            } 
          })]
        }
      }
    },
    quitarPagoRecibo: (state,action) => {
      const { payload } = action;
      const { section, poliza } = payload;
      return {
        ...state,
        home: {
          ...state.home,
          [section]: [...state.home[section].filter( element => {
            if(element.numero_poliza!==poliza){
              return element
            } 
          })]
        }
      }
    },
    updateContrato: (state,action) => {
      const { payload } = action;
      const { contratos, configuracion,nube } = payload;
      if(typeof contratos !== 'undefined'){
        if(contratos!==''){
          state.home.arrContrato.contratos = contratos;
        }
      }
      if(typeof configuracion !== 'undefined'){
        if(configuracion!==''){
          state.home.arrContrato.configuracion = configuracion;
        }
      }
      if(typeof nube !== 'undefined'){
        if(nube!==''){
          state.home.arrContrato.nube = nube;
        }
      }
    },
    actualizarEndoso: (state,action) => {
      const { payload } = action;
      const newArray =  {...state.home.arrContrato,...payload};
      state.home.arrContrato = newArray;
    },
    showAlert: (state,action) => {
      const { payload } = action;
      const { show, message, type, } = payload;
      state.toastAlert.show = show;
      state.toastAlert.message = message;
      if(typeof type !== 'undefined')
        state.toastAlert.type = type;
      else
        state.toastAlert.type = 'success';
    },
    setStateDirectorio: (state,data) => {
      state.directorio = data.payload
    },
    setStateNube: (state,data) => {
      state.nube = data.payload
    },
    setStateProductividad: (state,data) => {
      state.productividad = data.payload
    },
    setStateActividad: (state,data) => {
      state.actividad = data.payload
    },
    setStateConfiguracion: (state,data) => {
      state.configuracion = data.payload
    }
  }
})

export const { 
  loginSuccess, 
  changeName, 
  setInitData, 
  setStateHome,
  setStateHomeDataRecibo,
  setStateHomeRecibo,
  setStateDirectorio,
  setStateNube,
  setStateProductividad,
  setStateActividad,
  setStateConfiguracion,
  marcarPagoRecibo,
  quitarPagoRecibo,
  updatePrimaNetaRecibo,
  updateStatusRecibo,
  updateStatusEndoso,
  actualizarEndoso,
  showAlert,
  updateContrato,

  updateModalNuevaCotizacionStatus,
  setStateGlobal,
} = agentsSlice.actions

export default agentsSlice.reducer
